var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-phaser',{ref:"ionphaser",domProps:{"game":_vm.game,"initialize":_vm.initialize}})}
var staticRenderFns = []

export { render, staticRenderFns }